import clsx from 'clsx';
import { LandingPageContent } from './landing-page-content';
import { Navbar } from '@common/ui/navigation/navbar/navbar';
import { Button, ButtonProps } from '@ui/buttons/button';
import { IconButton } from '@ui/buttons/icon-button';
import { KeyboardArrowDownIcon } from '@ui/icons/material/KeyboardArrowDown';
import { Footer } from '@common/ui/footer/footer';
import { Trans } from '@ui/i18n/trans';
import { AdHost } from '@common/admin/ads/ad-host';
import { Link, useNavigate } from 'react-router';
import { createSvgIconFromTree } from '@ui/icons/create-svg-icon';
import { MenuItemConfig } from '@common/menus/menu-config';
import { Fragment } from 'react';
import { DefaultMetaTags } from '@common/seo/default-meta-tags';
import { useTrans } from '@ui/i18n/use-trans';
import { useSettings } from '@ui/settings/use-settings';
import { MixedImage } from '@ui/images/mixed-image';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import { arrow } from '@floating-ui/react-dom';
import { useActiveBanners } from '@app/landing/requests/use-active-banners';
import { Banner } from '@app/admin/banners/banner';



// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

interface ContentProps {
  content: LandingPageContent;
}


export function LandingPage() {
  const settings = useSettings();
  const homepage = settings.homepage as { appearance: LandingPageContent };

  return (
    <Fragment>
      <DefaultMetaTags />
      <div>
        <HeroHeader content={homepage.appearance} />
        {/* <SecondaryFeatures content={homepage.appearance} /> */}
        {/* <AboutUs /> */}
        {/* <AdHost slot="landing-top" className="mb-14 px-14 md:mb-60" /> */}

        <HomeBanner content={homepage.appearance} />
        <Brands content={homepage.appearance} />
        <PrimaryFeatures content={homepage.appearance} />
        <CounterUp content={homepage.appearance} />
        {/* <Products /> */}
        {/* <Plans /> */}
        {/* <div className="my-40 h-1 bg-divider" /> */}
        {/* <BottomCta content={homepage.appearance} /> */}
        <Footer className="landing-container" />
      </div>
    </Fragment>
  );
}

function HeroHeader({
  content: {
    headerTitle,
    headerSubtitle,
    headerImage,
    headerImageOpacity,
    actions,
    headerOverlayColor1,
    headerOverlayColor2,
  },
}: ContentProps) {
  const { trans } = useTrans();

  let overlayBackground = undefined;

  if (headerOverlayColor1 && headerOverlayColor2) {
    overlayBackground = `linear-gradient(45deg, ${headerOverlayColor1} 0%, ${headerOverlayColor2} 100%)`;
  } else if (headerOverlayColor1) {
    overlayBackground = headerOverlayColor1;
  } else if (headerOverlayColor2) {
    overlayBackground = headerOverlayColor2;
  }

  useEffect(() => {
    AOS.init({
      duration: 1500
    });
  }, []);

  return (
    <header
      className="relative h-200 md:mb-40 md:h-screen"
      style={{ background: overlayBackground }}
    >
      <div
        data-testid="headerImage"
        className="absolute inset-0 z-10 bg-cover bg-1/2 bg-no-repeat md:bg-fixed"
        style={{
          backgroundImage: `url(${headerImage})`,
          opacity: headerImageOpacity,
        }}
      />
      <div className="relative z-20 flex h-full flex-col">
        <Navbar
          color="transparent"
          className="flex-shrink-0"
          menuPosition="homepage-navbar"
        />
        <div className="mx-auto flex max-w-750 flex-auto flex-col items-center justify-center px-14 text-center text-white">
          {headerTitle && (
            <h1
              className="text-4xl font-medium md:text-5xl"
              data-testid="headerTitle"
            >
              <Trans message={headerTitle} />
            </h1>
          )}
          {headerSubtitle && (
            <div
              className="mt-30 text-lg md:mt-10 md:text-xl"
              data-testid="headerSubtitle"
            >
              <Trans message={headerSubtitle} />
            </div>
          )}
          <div className="mt-30 flex min-h-90 gap-20">
            <CtaButton
              item={actions?.cta1}
              variant="raised"
              color="primary"
              size="lg"
              radius="rounded-full"
              data-testid="cta1"
              className="min-w-180"
            />
            <CtaButton
              item={actions?.cta2}
              variant="text"
              color="paper"
              size="lg"
              radius="rounded-full"
              data-testid="cta2"
            />
          </div>
        </div>
      </div>
      {/* <IconButton
        size="lg"
        className="absolute bottom-5 left-0 right-0 z-10 mx-auto text-white max-md:hidden"
        elementType="a"
        aria-label={trans({ message: 'View features' })}
        href="#primary-features"
      >
        <KeyboardArrowDownIcon />
      </IconButton> */}
    </header>
  );
}

interface CtaButtonProps extends ButtonProps {
  item?: MenuItemConfig;
}
function CtaButton({ item, ...buttonProps }: CtaButtonProps) {
  if (!item?.label) return null;
  const Icon = item.icon ? createSvgIconFromTree(item.icon) : undefined;
  return (
    <Button
      elementType={item.type === 'route' ? Link : 'a'}
      href={item.action}
      to={item.action}
      startIcon={Icon ? <Icon /> : undefined}
      {...buttonProps}
    >
      <Trans message={item.label} />
    </Button>
  );
}

interface Props {
  content: LandingPageContent;
}
function HomeBanner({content}: Props) {
  const {data: bannersData} = useActiveBanners();
  const banners = bannersData?.banners ?? [];

  return (
    <>
      {/* <Navbar
        color="transparent"
        className="flex-shrink-0"
        menuPosition="homepage-navbar"
      /> */}
      <div>
        <section className='banner_section'>
          <div className='landing-container'>
            <div className='row justify-content-center text-center'>
              <div className='col-lg-8 mb-4'>
                {banners.length ? (
                  <DynamicHomeBanners banners={banners} />
                ) : (
                  <>
                    <div data-aos="fade-right">
                      <div className='banner_side_img'>
                        <img
                          src={content.bannerImage || 'images/homepage/banner_left.png'}
                          alt=""
                          data-testid="bannerImage"
                        />
                      </div>
                    </div>
                    <div data-aos="fade-up-right">
                      <div className='baner_contents'>
                        <h1 data-testid="bannerTitle">
                          <span>{content.bannerTitleHighlight || '1024GB'}</span>{' '}
                          {content.bannerTitle || 'Cloud Storage'}
                        </h1>
                        <p data-testid="bannerDescription">
                          {content.bannerDescription ||
                            'Register or Login now to upload, backup, manage and access your files on any device, from anywhere, free.'}
                        </p>
                        <div className='banner_btn mb-4 justify-content-center'>
                          <a
                            className='get_btn'
                            href={content.bannerButton1Link || '#'}
                          >
                            {content.bannerButton1Text || 'Get Start'}
                          </a>
                          <a
                            className='download_btn'
                            href={content.bannerButton2Link || '#'}
                          >
                            {content.bannerButton2Text || 'Download'}
                          </a>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const bannerCarouselSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
};

interface DynamicHomeBannersProps {
  banners: Banner[];
}
function DynamicHomeBanners({banners}: DynamicHomeBannersProps) {
  const slides = banners.map(banner => (
    <div key={banner.id}>
      {banner.image && (
        <div className='banner_side_img'>
          <img src={banner.image} alt={banner.title || ''} />
        </div>
      )}
      <div className='baner_contents'>
        {banner.title && <h1>{banner.title}</h1>}
        {banner.description && <p>{banner.description}</p>}
        {banner.button_text && (
          <div className='banner_btn mb-4'>
            <a
              className='get_btn'
              href={banner.button_link || '#'}
            >
              {banner.button_text}
            </a>
          </div>
        )}
      </div>
    </div>
  ));

  if (banners.length === 1) {
    return <>{slides[0]}</>;
  }

  return <Slider {...bannerCarouselSettings}>{slides}</Slider>;
}

// function Brands() {
//   return (
//     <>
//       <section className='brand_section'>
//         <div className='landing-container'>
//           <div className='brands_head'>
//             <h5>Used by people working at:</h5>
//           </div>
//           <div className='row'>
//             <div className='col-lg-2'>
//               <div className='brand_img'>
//                 <img src="images/homepage/brand_1.png" alt="" />
//               </div>
//             </div>
//             <div className='col-lg-2'>
//               <div className='brand_img'>
//                 <img src="images/homepage/brand_2.png" alt="" />
//               </div>
//             </div>
//             <div className='col-lg-2'>
//               <div className='brand_img'>
//                 <img src="images/homepage/brand_3.png" alt="" />
//               </div>
//             </div>
//             <div className='col-lg-2'>
//               <div className='brand_img'>
//                 <img src="images/homepage/brand_4.png" alt="" />
//               </div>
//             </div>
//             <div className='col-lg-2'>
//               <div className='brand_img'>
//                 <img src="images/homepage/brand_5.png" alt="" />
//               </div>
//             </div>
//             <div className='col-lg-2'>
//               <div className='brand_img'>
//                 <img src="images/homepage/brand_6.png" alt="" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   )
// }


const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  loop: true,
  autoplay: false,
  slidesToShow: 6, // Adjust this based on your layout
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },

    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
};

const defaultBrands = [
  {image: 'images/homepage/brand_1.png'},
  {image: 'images/homepage/brand_2.png'},
  {image: 'images/homepage/brand_3.png'},
  {image: 'images/homepage/brand_4.png'},
  {image: 'images/homepage/brand_5.png'},
  {image: 'images/homepage/brand_6.png'},
];

function Brands({content}: ContentProps) {
  const brands = content.brands?.length ? content.brands : defaultBrands;
  return (
    <>
      <section className='brand_section'>
        <div className='landing-container'>
          <div data-aos="fade-left">
            <div className='brands_head'>
              <h5 data-testid="brandsHeading">
                {content.brandsHeading || 'Used by people working at:'}
              </h5>
            </div>
          </div>
          <Slider {...settings}>
            {brands.map((brand, index) => (
              <div className='brand_img' key={index}>
                <img
                  src={brand.image}
                  alt={`Brand ${index + 1}`}
                  data-testid={`brand-image-${index}`}
                />
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  )
}






function SecondaryFeatures({ content }: ContentProps) {
  return (
    // <div className="landing-container">
    //   {content?.secondaryFeatures?.map((feature, index) => {
    //     const isEven = index % 2 === 0;
    //     return (
    //       <div
    //         key={index}
    //         data-testid={`secondary-root-${index}`}
    //         className={clsx(
    //           'mb-14 py-16 md:mb-80 md:flex',
    //           isEven && 'flex-row-reverse',
    //         )}
    //       >
    //         <img
    //           src={feature.image}
    //           className=""
    //           data-testid={`secondary-image-${index}`}
    //           alt=""
    //         />
    //         <div className="">
    //           <small
    //             className="mb-16 text-xs font-medium uppercase tracking-widest text-muted"
    //             data-testid={`secondary-subtitle-${index}`}
    //           >
    //             <Trans message={feature.subtitle} />
    //           </small>
    //           <h3
    //             className="py-16 text-3xl"
    //             data-testid={`secondary-title-${index}`}
    //           >
    //             <Trans message={feature.title} />
    //           </h3>
    //           <div className="h-2 w-50 bg-black/90" />
    //           <div
    //             className="my-20 text-[0.938rem]"
    //             data-testid={`secondary-description-${index}`}
    //           >
    //             <Trans message={feature.description} />
    //           </div>
    //         </div>



    //       </div>


    //     );
    //   })}
    // </div>

    <div className='feature_section'>

      <div className="landing-container">
        {content?.secondaryFeatures?.map((feature, index) => {
          const isEven = index % 2 === 0;
          return (
            <div
              key={index}
              data-testid={`secondary-root-${index}`}
              className={clsx(
                'md:flex',
                isEven && 'flex-row-reverse',
              )}
            >

              <div className="col-lg-6 mb-3">
                <div className='feature_contents'>
                  {/* <small
                    className="mb-16 text-xs font-medium uppercase tracking-widest text-muted"
                    data-testid={`secondary-subtitle-${index}`}
                  >
                    <Trans message={feature.subtitle} />
                  </small> */}
                  <h3 data-testid={`secondary-title-${index}`}>
                    <Trans message={feature.title} />
                  </h3>

                  <p data-testid={`secondary-description-${index}`}>
                    <Trans message={feature.description} />
                  </p>

                  <div className='feature_btn'>
                    <button type='button'>Get Start</button>
                  </div>

                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className='secondary_img'>
                  <img
                    src={feature.image}
                    className=""
                    data-testid={`secondary-image-${index}`}
                    alt=""
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>

    </div>

  );
}




function AboutUs() {
  return (
    <>
      <div>
        <section className='about_section'>
          <div className='landing-container'>
            <div className='row'>
              <div className='col-lg-6 mb-4'>
                <div className='about_contents'>
                  <h1><span>Onetime </span>protects data security</h1>
                  <p>Onetime highly values your data security and privacy protection, and safeguards your cloud data through its industry-leading storage capacity and technology certification.</p>
                  <div className='about_btn'>
                    <button>More about security</button>
                    <img src="images/homepage/arrow_img.png" alt="" />
                  </div>
                </div>
              </div>
              <div className='col-lg-6 mb-4'>
                <div className='banner_side_img'>
                  <img src="images/homepage/about_img.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}


const feature = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  loop: true,
  autoplay: false,
  slidesToShow: 4, // Adjust this based on your layout
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },

    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function PrimaryFeatures({ content }: ContentProps) {
  const navigate = useNavigate();
  return (

    <div className="items-stretch" id="primary-features">

      <div className='landing-container'>
        <div data-aos="fade-right">
          <div className="privileges_head">
            <h1>Privileges for Premium Users</h1>
          </div>
        </div>
        <div data-aos="fade-up-left">
          <div className="plan_btn">
            <button onClick={() => navigate('/pricing')}>View Detailed Plan</button>
            <img src="images/homepage/arrow_img.png" alt="" />
          </div>
        </div>
      </div>

      <div className='future_bg'>
        <div className='landing-container'>
          <Slider {...feature}>
            {content?.primaryFeatures?.map((feature, index) => (
              <div key={index} data-aos="zoom-in">
                <div key={index} className="privilage_shadow">
                  <div className="privilage_icons">
                    <img
                      data-testid={`primary-image-${index}`}
                      src={feature.image}
                      alt={feature.title}
                    />
                  </div>
                  <h2 data-testid={`primary-title-${index}`}>
                    <Trans message={feature.title} />
                  </h2>
                  <p data-testid={`primary-subtitle-${index}`}>
                    <Trans message={feature.subtitle} />
                  </p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

const defaultStats: LandingPageContent['stats'] = [
  {number: '400 M+', label: 'Registered users'},
  {number: '23 M+', label: 'Daily active users'},
  {number: '231 M+', label: 'Countries or regions'},
];

function CounterUp({content}: ContentProps) {
  const stats = content.stats?.length ? content.stats : defaultStats;

  return (
    <>
      <section className='counter_up_section'>
        <div className='landing-container'>
          <div className="privileges_head">
            <h1 data-aos="fade-right" data-testid="stats-heading">
              {content.statsHeading || 'Trusted by Hundreds of Millions of Users Globally'}
            </h1>
            <p data-aos="fade-left" data-testid="stats-subtitle">
              {content.statsSubtitle || 'Enhance the value of your product through integration.'}
            </p>
          </div>

          <div className='row justify-content-center pt-sm-5 pt-4'>
            {stats.map((stat, index) => (
              <div className='col-lg-4 col-md-4 col-sm-6 mb-4' key={index} data-testid={`stats-root-${index}`}>
                <div className='counter_contents' data-aos="fade-up">
                  <h1 data-testid={`stats-number-${index}`}>{stat.number}</h1>
                  <h3 data-testid={`stats-label-${index}`}>{stat.label}</h3>
                </div>
              </div>
            ))}
          </div>

          <div className='counteer_btns mb-4'>
            <a
              className='get_btn'
              data-aos="fade-right"
              href={content.statsButton1Link || '#'}
            >
              {content.statsButton1Text || 'Get Start'}
            </a>
            <a
              className='download_btn'
              data-aos="fade-left"
              href={content.statsButton2Link || '#'}
            >
              {content.statsButton2Text || 'Download'}
            </a>
          </div>

        </div>
      </section>
    </>
  )
}


function Products() {
  return (
    <>
      <div className='landing-container'>
        <div className="privileges_head">
          <h1>OneTime Can Be Integrated into Other Products</h1>
          <p>Enhance the value of your product through integration.</p>
        </div>

        <div className='row pt-3'>
          <div className='col-lg-4 mb-4'>
            <div className='product_img'>
              <img src="images/homepage/product_1.png" alt="" />
            </div>
          </div>
          <div className='col-lg-4 mb-4'>
            <div className='product_img pro_2'>
              <img src="images/homepage/product_2.png" alt="" />
            </div>
          </div>
          <div className='col-lg-4 mb-4'>
            <div className='product_img'>
              <img src="images/homepage/product_3.png" alt="" />
            </div>
          </div>
        </div>

      </div>
    </>
  )
}



function Plans() {
  return (
    <>
      <div>
        <section className='plan_section'>
          <div className='landing-container'>
            <div className="privileges_head">
              <h1>Select a OneTime plan suitable for you</h1>
            </div>
          </div>

          <div className='plan_bg'>
            <div className='landing-container'>
              <div className='row'>
                <div className='col-lg-4 mb-4'>
                  <div className="wrapper">
                    <div className='first_plan '>
                      <h3>Basic version</h3>
                      <h1>Free</h1>
                      <div className='tick'>
                        <div>
                          <img src="images/homepage/tick_img.png" alt="" />
                        </div>
                        <p>1024 GB of cloud storage</p>
                      </div>
                      <div className='tick'>
                        <div>
                          <img src="images/homepage/tick_img.png" alt="" />
                        </div>
                        <p>1024 GB of cloud storage</p>
                      </div>
                      <div className='tick'>
                        <div>
                          <img src="images/homepage/tick_img.png" alt="" />
                        </div>
                        <p>1024 GB of cloud storage</p>
                      </div>
                      <div className='tick'>
                        <div>
                          <img src="images/homepage/tick_img.png" alt="" />
                        </div>
                        <p>1024 GB of cloud storage</p>
                      </div>
                      <div className='tick'>
                        <div>
                          <img src="images/homepage/tick_img.png" alt="" />
                        </div>
                        <p>1024 GB of cloud storage</p>
                      </div>

                      <div className='now_btn'>
                        <button type='button'>Explore Now</button>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-lg-4 mb-4'>
                  <div className='second_plan '>
                    <h3>Lowest price</h3>
                    <h1>Premium</h1>
                    <div className='tick'>
                      <div>
                        <img src="images/homepage/tick_img.png" alt="" />
                      </div>
                      <p>1024 GB of cloud storage</p>
                    </div>
                    <div className='tick'>
                      <div>
                        <img src="images/homepage/tick_img.png" alt="" />
                      </div>
                      <p>1024 GB of cloud storage</p>
                    </div>
                    <div className='tick'>
                      <div>
                        <img src="images/homepage/tick_img.png" alt="" />
                      </div>
                      <p>1024 GB of cloud storage</p>
                    </div>
                    <div className='tick'>
                      <div>
                        <img src="images/homepage/tick_img.png" alt="" />
                      </div>
                      <p>1024 GB of cloud storage</p>
                    </div>
                    <div className='tick'>
                      <div>
                        <img src="images/homepage/tick_img.png" alt="" />
                      </div>
                      <p>1024 GB of cloud storage</p>
                    </div>

                    <div className='purchase'>
                      <button type='button'>Purchase</button>
                    </div>
                  </div>
                </div>
                <div className='col-lg-4 mb-4'>
                  <div className="wrapper_3">
                    <div className='first_plan '>
                      <h3>Advanced version</h3>
                      <h1>Elite</h1>
                      <div className='tick'>
                        <div>
                          <img src="images/homepage/tick_img.png" alt="" />
                        </div>
                        <p>1024 GB of cloud storage</p>
                      </div>
                      <div className='tick'>
                        <div>
                          <img src="images/homepage/tick_img.png" alt="" />
                        </div>
                        <p>1024 GB of cloud storage</p>
                      </div>
                      <div className='tick'>
                        <div>
                          <img src="images/homepage/tick_img.png" alt="" />
                        </div>
                        <p>1024 GB of cloud storage</p>
                      </div>
                      <div className='tick'>
                        <div>
                          <img src="images/homepage/tick_img.png" alt="" />
                        </div>
                        <p>1024 GB of cloud storage</p>
                      </div>
                      <div className='tick'>
                        <div>
                          <img src="images/homepage/tick_img.png" alt="" />
                        </div>
                        <p>1024 GB of cloud storage</p>
                      </div>

                      <div className='rd_btn'>
                        <button type='button'>Explore Now</button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}






function BottomCta({ content }: ContentProps) {
  return (
    <div
      className="relative bg-[#2B2B2B] bg-no-repeat py-70 text-center text-on-primary md:bg-fixed"
      style={{ backgroundImage: `url("${content.footerImage}")` }}
      data-testid="footerImage"
    >
      <h2
        className="mx-auto max-w-620 text-3xl font-normal"
        data-testid="footerTitle"
      >
        <Trans message={content.footerTitle} />
      </h2>
      {content.footerSubtitle && (
        <p
          className="mx-auto mt-50 max-w-620 text-2xl font-normal"
          data-testid="footerSubtitle"
        >
          <Trans message={content.footerSubtitle} />
        </p>
      )}
      <CtaButton
        item={content.actions?.cta3}
        size="lg"
        variant="outline"
        color="paper"
        className="mt-50 block"
        data-testid="cta3"
      />
    </div>
  );
}
